import { render } from "./OmnyModalHeader.vue?vue&type=template&id=3606d9d6&scoped=true"
import script from "./OmnyModalHeader.vue?vue&type=script&lang=js"
export * from "./OmnyModalHeader.vue?vue&type=script&lang=js"

import "./OmnyModalHeader.vue?vue&type=style&index=0&id=3606d9d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3606d9d6"]])

export default __exports__